import React from 'react'
import { Row, Col, ListGroup } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'

const SynchronisationHeader = () => {
  const {t} = useTranslation()

  const style = {
    theader:{
      fontWeight: "bold"
    }
  }
  return(
    <ListGroup.Item>
      <Row>
        <Col lg={4} md={4}>
          <span style={style.theader}>{t('sync-header-taskname')}</span>
        </Col>
        <Col xs={false} lg={3} md={3}>
          <span style={style.theader}>{t('sync-header-description')}</span>
        </Col>
        <Col lg={3} md={3}>
          <span style={style.theader}>{t('sync-header-state')}</span>
        </Col>
        <Col lg={2} md={2}>
          <span style={style.theader}>{t('sync-header-action')}</span>
        </Col>
      </Row>
    </ListGroup.Item>
  )
}

export default SynchronisationHeader